import { ComponentProps } from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";
import { Select } from "../Select";

type SelectProps = Omit<ComponentProps<typeof Select>, "value" | "onChange">;

interface FormSelectProps<TFieldValues extends FieldValues>
  extends SelectProps {
  name: UseControllerProps<TFieldValues>["name"];
  control: UseControllerProps<TFieldValues>["control"];
}

const FormSelect = <TFieldValues extends FieldValues>({
  name,
  control,
  ...props
}: FormSelectProps<TFieldValues>) => {
  const { field, fieldState } = useController({ name, control });
  return <Select {...props} {...field} error={fieldState.error?.message} />;
};

export { FormSelect };
